import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import {
    getPreFillFromQuery
} from '../../../common/util/util-helpers'
import {Field, FieldsManager} from '../../../data/services/fields'
import {createResource, resetResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import InfoTab from './infoTab'
import {
    CREATE_PERM,
    NUMBER_OF_AXLES,
    READ_PERM,
    SCAC_CODE_FIELD_LENGTH,
    VIN_CODE_FIELD_LENGTH
} from '../../../util/util-constants'
import {
    checkPerm, getDefaultContactGroup,
    getDefaultUserOfficeValues, getDocumentTypesFor,
    getLookup,
    getProp,
    getSubLookupFor
} from '../../../common/util/util-helpers'
import {scrollErrorIntoViewFields} from '../../../common/util/util-vanilla'
import {InformationCircleIcon} from "@heroicons/react/24/outline";
import GroupsViewDialog from "../../my-company/groups-view/groups-view-dialog";
import Page from "../../../common/components/layout/layout-components/page";
import GoBackButton from "../../../common/components/layout/layout-components/go-back-button";
import Layout from "../../../common/components/layout";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import ResourceCreateListTab from "../../../common/components/tabs/resource-create-list-tab";
import Card from "../../../common/components/card";
import DocumentsCreateTab from "../../../common/components/tabs/documents-tab/create-documents";
import PageFooter from "../../../common/components/layout/layout-components/page/page-footer";
import RedirectDialog from "../../../common/components/modal/redirect-dialog";
import {fillFieldsFromData} from "../../../common/util/util-fields";
import FieldOptions from "../../../common/components/fields/field-options";

class TrailerCreateView extends Component {

    constructor(props) {
        super(props)

        const tabs = [
            {
                name: 'Trailer',
                resource: Resources.Trailer,
                current: true,
                visible: checkPerm(Resources.Trailer, READ_PERM)
            },
            {
                name: 'TrailerType',
                resource: Resources.TrailersTypes,
                current: false,
                visible: checkPerm(Resources.TrailersTypes, READ_PERM)
            },
            {
                name: 'TrailersService',
                resource: Resources.TrailersService,
                current: false,
                visible: checkPerm(Resources.TrailersService, READ_PERM)
            },
            {
                name: 'TrailerDocuments',
                resource: Resources.TrailerDocuments,
                current: false,
                visible: checkPerm(Resources.TrailerDocuments, CREATE_PERM)
            },
        ]

        this.state = {
            // Tabs
            tabs: tabs,
            selectedTab: Resources.Trailer,

            // Fields
            fields_info: this.getFieldsInfo(),
            fields_documents: [],
            fields_services: [],
            fields_types: [],
            canSwapTabs: true,
            emailExist: false,

            // Modals
            redirectModalOpen: false,
            isGroupInfoDialogOpen: false,
            groupInfoData: {},
        }

        this.fieldsRef = {}
    }

    /** Lifecycle
     ================================================================= */
    componentDidUpdate(prevProps) {
        if (this.props.resource !== prevProps.resource && !prevProps.resource.showRedirectDialog && !!this.props.resource.showRedirectDialog) {
            this.handleToggleRedirectModal()
        }
    }

    /** Data Events
     ================================================================= */
    onSubmit = () => {
        this.setState({
            fields_info: FieldsManager.validateFields(this.state.fields_info),
        }, () => {
            if (FieldsManager.checkFieldsForErrors(this.state.fields_info)) {
                let params = Object.assign({},
                    FieldsManager.getFieldKeyValues(this.state.fields_info),
                    {
                        Services: this.state.fields_services,
                        WarrantyMileage: this.state.fields_info.WarrantyMileage.value.replace(',', ''),
                        Types: this.state.fields_types,
                    }
                )
                this.props.dispatch(createResource({
                    user: LocalStorage.get('user'),
                    params: params,
                    resource: Resources.Trailers,
                    showRedirectDialog: true,
                    errorMessage: true,
                    document: this.state.fields_documents,
                    documentResource: Resources.TrailerDocuments,
                }))
            } else {
                this.handleTabChange(Resources.Trailer)
                scrollErrorIntoViewFields([this.state.fields_info])
            }
        })
    }

    /** UI Events
     ================================================================= */
    handleFormCancel = () => {
        this.setState({
            fields_info: this.getFieldsInfo(),
            canSubmit: false
        })
    }

    handleToggleRedirectModal = () => {
        this.setState({
            createdResourceID: this.props.resource.create && this.props.resource.create.id,
            redirectModalOpen: !this.state.redirectModalOpen,
            fields_info: this.getFieldsInfo(),
            fields_documents: [],
            fields_services: [],
            canSubmit: false
        })
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }
        this.tabChange(resource)
    }

    tabChange = (resource) => {
        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }

    handleInputChange = (name, value, nextElementRef) => {
        if (nextElementRef) {
            this.fieldsRef[nextElementRef].focus()
        }
        const fields = FieldsManager.updateField(this.state.fields_info, name, value)
        if (name === "OwnedByID") {
            fields["OwnedByContactID"].value = ''
            fields["OwnedByOrganizationID"].value = ''

            fields["OwnedByContactID"].disabled = value === 2
            fields["OwnedByOrganizationID"].disabled = value === 1
        }

        if (name === 'OwnedByCompany') {
            fields['OwnedByID'].disabled = !!value
            fields['OwnedByContactID'].disabled = true
            fields['OwnedByOrganizationID'].disabled = true
            fields['TrailerOwnershipTypeID'].disabled = !!value
            fields['OwnedByID'].value = null
            fields['OwnedByContactID'].value = null
            fields['OwnedByOrganizationID'].value  = null
            fields['TrailerOwnershipTypeID'].value  = null
        }

        this.setState({canSubmit: true, fields_info: fields})
    }

    handleItemInputChange = (i, name, value) => {
        let fields = this.state.phones_info[i]
        const newItems = this.state.phones_info
        newItems[i] = FieldsManager.updateField(fields, name, value)
        this.setState({canSubmit: true, phones_info: newItems})
    }

    handleUploadDocument = (files) => {
        let fields = this.state.fields_documents
        fields = fields.concat(files)
        this.setState({fields_documents: fields})
    }

    handleDeleteDocument = (item) => {
        let fields = this.state.fields_documents.filter(it => it.preview !== item.preview)
        this.setState({fields_documents: fields})
    }

    handleGroupInfoClick = (groupData) => {
        this.setState({
            isGroupInfoDialogOpen: true,
            groupInfoData: groupData
        })
    }

    handleAddToListTab = (state, params) => {
        this.setState({[state]: [...this.state[state], params].map((item, index) => ({...item, index}))})
    }

    handleEditListTab = (state, params) => {
        const newData = this.state[state].map((item, index) => {
            item.index = index
            if (index === getProp(params, 'index', 0)) {
                item = params
            }
            return item
        })
        this.setState({[state]: newData})
    }

    handleRemoveFromListTab = (state, params) => {
        let dataTmp = [...this.state[state]]
            .filter((item, index) => getProp(params, 'index', 0) !== index)
            .map((item, index) => ({...item, index}))
        this.setState({[state]: dataTmp})
    }

    /** Fields/Data Definitions
     ================================================================= */
    getFieldsInfo = () => {
        const prefilled = getPreFillFromQuery()

        let VINPrefilled;

        const isValidJSON = str => {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        };

        if (isValidJSON(prefilled)) {
            VINPrefilled = JSON.parse(prefilled)
        }
        return {
            SCAC: new Field('SCAC', '', [''], false, 'text', {addContainerClass: 'col-span-3 md:col-span-2'}, {
                upperCaseOnly: true,
                max: SCAC_CODE_FIELD_LENGTH
            }),
            TrailerNumber: new Field('TrailerNumber', !VINPrefilled?.Model ? prefilled : '', ['empty'], false, 'text', {addContainerClass: 'col-span-3 md:col-span-2'}),
            Year: new Field('Year', VINPrefilled?.Year ?? '', [''], false, 'select', {addContainerClass: 'col-span-3 md:col-span-2'}),
            TrailerLicenceNumber: new Field('TrailerLicenceNumber', '', [''], false, 'text', {addContainerClass: 'col-span-3'}),
            TrailerLicenceStateID: new Field('TrailerLicenceStateID', '', [''], false, 'select', {addContainerClass: 'col-span-3'}, {
                values: getLookup('State')
            }),
            TrailerTypeID: new Field('TrailerTypeID', '', [''], false, 'select', {addContainerClass: 'col-span-3'}),
            Manufacturer: new Field('Manufacturer', VINPrefilled?.Manufacturer ?? '', [''], false, 'text', {addContainerClass: 'col-span-3'}),
            Model: new Field('Model', VINPrefilled?.Model ?? '', [''], false, 'text', {addContainerClass: 'col-span-3'}),
            Engine: new Field('Engine', VINPrefilled?.Engine ?? '', [''], false, 'text', {addContainerClass: 'col-span-3'}),
            VIN: new Field('VIN', VINPrefilled?.VIN ?? '', ['length_===_17'], false, 'text', {addContainerClass: 'col-span-3'}, {
                max: VIN_CODE_FIELD_LENGTH,
                upperCaseOnly: true,
                numbersAndLettersOnly: true
            }),
            OfficeID: new Field('OfficeID', getDefaultUserOfficeValues(), ['empty'], false, 'select-search', {addContainerClass: 'col-span-3'}),
            ContactGroupID: new Field('ContactGroupID', getDefaultContactGroup(), ['empty'], false, 'select-search', {
                addContainerClass: 'col-span-3', label: "FleetGroupID",
                fieldOptions: (it) => {
                    return (
                        <FieldOptions
                            options={[
                                {
                                    icon: InformationCircleIcon,
                                    onClick: () => this.handleGroupInfoClick(it?.value?.metadata),
                                    isVisible: !!it.value
                                }
                            ]}
                        />
                    )
                }
            }, {
                isClearable: true,
                api: 'api/' + Resources.ContactGroupsQuick,
                query: {},
                searchMap: (it) => ({
                    label: it.ContactGroupName,
                    value: it.ContactGroupID,
                    metadata: it
                })
            }),
            WarrantyMileage: new Field('WarrantyMileage', '', ['float_or_empty'], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),
            WarrantyDate: new Field('WarrantyDate', '', [''], false, 'date', {addContainerClass: 'col-span-3'}),
            InServiceDate: new Field('InServiceDate', '', [''], false, 'date', {addContainerClass: 'col-span-3'}),
            CarbID: new Field('CarbID', '', [''], false, 'text', {addContainerClass: 'col-span-3'}),
            Notes: new Field('Notes', '', [], false, 'textarea', {
                heightClass: 'h-52',
                addContainerClass: 'col-span-3'
            }),
            AssetCompanyStatusID: new Field('AssetCompanyStatusID', '', [], false, 'select', {}, {isClearable: true}),
            AssignmentNotes: new Field('AssignmentNotes', '', [], false, 'textarea', {
                heightClass: 'h-52',
                addContainerClass: 'col-span-3'
            }),
            TrailerUtilizationStatusID: new Field('TrailerUtilizationStatusID', '', [], false, 'select', {}, {isClearable: true}),
            TrailerUtilizationNotes: new Field('TrailerUtilizationNotes', '', [], false, 'textarea', {addContainerClass:'col-span-full'}),
            TrailerUnloadedWeight: new Field('TrailerUnloadedWeight', '', [''], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),
            TrailerGrossWeight: new Field('TrailerGrossWeight', '', [''], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),
            TrailerNumberOfAxles: new Field('TrailerNumberOfAxles', '', [''], false, 'select', {addContainerClass: 'col-span-3'}, {
                values: NUMBER_OF_AXLES
            }),
            TrailerLength: new Field('TrailerLength', '', [''], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),
            TrailerHeight: new Field('TrailerHeight', '', [''], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),

            OwnedByCompany: new Field('OwnedByCompany', '', [], false, 'checkbox', {addContainerClass: 'col-span-6'}),
            TrailerOwnershipTypeID: new Field('TrailerOwnershipTypeID', '', [''], false, 'select', {addContainerClass: 'col-span-full'}),
            OwnedByID: new Field('OwnedByID', 1, [''], false, 'button-group', {
                data: {
                    1: this.props.translate('field.OwnedByContactID'),
                    2: this.props.translate('field.OwnedByOrganizationID')
                },
                addContainerClass: 'col-span-6',
                hideLabel: true
            }),
            OwnedByContactID: new Field('OwnedByContactID', '', [''], false, 'select-search', {addContainerClass: 'col-span-3'}),
            OwnedByOrganizationID: new Field('OwnedByOrganizationID', '', [''], true, 'select-search', {addContainerClass: 'col-span-3'}),
            CurrentMarkerValue: new Field('CurrentMarkerValue', '', [''], false, 'float_or_empty', {addContainerClass: 'col-span-3'}),
            LastCurrentMarkerValueDate: new Field('LastCurrentMarkerValueDate', '', [''], false, 'date', {addContainerClass: 'col-span-3'}),
        }
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props;

        return (
            <Layout
                hasFooter={true}
                {...this.props}
                isDirty={this.state.canSubmit}>
                <Page>
                    <div className="flex justify-between items-center">
                        <div className="mb-2 flex justify-start items-center">
                            <GoBackButton
                                translate={this.props.translate}
                                history={this.props.history}
                                path={'/trailers'}
                            />

                            <h1
                                className={'mr-5 text-3xl ml-2'}> {translate('text.create')} {translate('page.heading.trailer')}
                            </h1>
                        </div>
                    </div>

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.Trailer && (
                        <InfoTab
                            handleItemInputChange={this.handleItemInputChange}
                            handleInputChange={this.handleInputChange}
                            fields_info={this.state.fields_info}
                            fieldsRef={this.fieldsRef}
                            isLoading={resource.isLoading}
                            {...this.props}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrailersTypes && (
                        <ResourceCreateListTab
                            data={this.state.fields_types}
                            translate={translate}
                            dialogTitle={translate('modal_heading.TrucksTypes')}

                            resourceName={Resources.TrailersTypes}
                            fields={{
                                TrailerTypeID: new Field('TrailerTypeID', '', ['empty'], false, 'select', {
                                    addContainerClass: 'col-span-3',
                                    label: 'TrailerSpec'
                                }, {
                                    values: getLookup('TruckType')
                                }),
                                TrailerTypeSubItemID: new Field('TrailerTypeSubItemID', '', ['empty'], false, 'select', {
                                    addContainerClass: 'col-span-3',
                                    label: 'TrailerSubSpec'
                                }, {}),
                                Notes: new Field('Notes', '', [''], false, 'textarea', {addContainerClass: 'col-span-3'}),
                            }}
                            metadata={{
                                TrailerTypeID: getProp(LocalStorage.get('lookup'), 'TruckType', []).reduce(
                                    (memo, item) => {
                                        memo[item['TruckTypeID']] = item['TruckType'] + (item.TruckTypeSubItems.length === 0 ? ' (Has no SubItems)' : '');
                                        return memo;
                                    }, {})
                            }}
                            fillFieldTemplate={(fields, item = null) => {
                                fields = fillFieldsFromData(fields, item)

                                if (item && item.TrailerTypeSubItemID) {
                                    const TruckSubTypes = getProp(LocalStorage.get('lookup'), 'TruckType', []).find(it => it.TruckTypeID == item.TrailerTypeID)
                                    fields['TrailerTypeSubItemID'].props.values = getProp(TruckSubTypes, 'TruckTypeSubItems', []).reduce((memo, it) => {
                                        memo[it.TruckTypeSubItemID] = it.TruckTypeSubItem
                                        return memo
                                    }, {})
                                }

                                return fields
                            }}

                            onAddItem={(params) => {
                                const TruckTypeSubItem = getProp(getSubLookupFor('TruckType', params.TrailerTypeID), 'TruckTypeSubItems', [])
                                    .find(it => it.TruckTypeSubItemID == params.TrailerTypeSubItemID)
                                const data = [...this.state.fields_types, {
                                    ...params,
                                    TrailerTypeSubItem: TruckTypeSubItem?.TruckTypeSubItem ?? '',
                                    index: this.state.fields_types.length
                                }]
                                this.setState({fields_types: data})
                            }}
                            onEditItem={(params) => {
                                const newData = this.state.fields_types.map((item, index) => {

                                    item.index = index
                                    if (index === getProp(params, 'index', 0)) {
                                        const TruckTypeSubItem = getProp(getSubLookupFor('TruckType', params.TrailerTypeID), 'TruckTypeSubItems', [])
                                            .find(it => it.TruckTypeSubItemID == params.TrailerTypeSubItemID)
                                        item = {
                                            ...params,
                                            TrailerTypeSubItem: TruckTypeSubItem?.TruckTypeSubItem ?? '',
                                        }
                                    }
                                    return item
                                })
                                this.setState({fields_types: newData})
                            }}

                            onRemoveItem={(params) => this.handleRemoveFromListTab('fields_types', params)}

                            handleInputChange={(fields, name, value) => {
                                if (name === "TrailerTypeID") {
                                    const TruckSubTypes = getProp(LocalStorage.get('lookup'), 'TruckType', []).find(it => it.TruckTypeID == value)
                                    fields['TrailerTypeSubItemID'].props.values = getProp(TruckSubTypes, 'TruckTypeSubItems', []).reduce((memo, it) => {
                                        memo[it.TruckTypeSubItemID] = it.TruckTypeSubItem
                                        return memo
                                    }, {})
                                    fields['TrailerTypeSubItemID'].value = ''
                                }
                                return FieldsManager.updateField(fields, name, value)
                            }}
                        />
                    )}

                    {this.state.selectedTab === Resources.TrailerDocuments && (
                        <Card>
                            <DocumentsCreateTab
                                fields={this.state.fields_documents}
                                translate={this.props.translate}

                                dialogTitle={'Employee Documents'}

                                documentTypes={getDocumentTypesFor("IsFleetDocument")}
                                handleUploadDocument={this.handleUploadDocument}
                                handleDeleteDocument={this.handleDeleteDocument}
                            />
                        </Card>
                    )}

                    {this.state.selectedTab === Resources.TrailersService && (
                        <ResourceCreateListTab
                            data={this.state.fields_services}
                            translate={translate}
                            dialogTitle={translate('modal_heading.TrailersService')}

                            resourceName={Resources.TrailersService}
                            fields={{
                                VendorID: new Field("VendorID", '', ['empty'], false, 'select-search', {addContainerClass: "col-span-full"}),
                                OutOfServiceDate: new Field("OutOfServiceDate", '', ['empty'], false, 'date', {addContainerClass: "col-span-full"}),
                                ReturnsToServiceDate: new Field("ReturnsToServiceDate", '', ['empty'], false, 'date', {addContainerClass: "col-span-full"}),
                                ServiceNotes: new Field("ServiceNotes", '', ['empty'], false, 'textarea', {addContainerClass: "col-span-full"}),
                            }}

                            getRawFields
                            onAddItem={(fields) => {
                                const params = Object.assign({}, FieldsManager.getFieldKeyValues(fields), {
                                    Vendor: fields.VendorID.value.label
                                })
                                this.handleAddToListTab('fields_services', params)
                            }}
                            onEditItem={(fields) => {
                                const params = Object.assign({}, FieldsManager.getFieldKeyValues(fields), {
                                    Vendor: fields.VendorID.value.label,
                                    index: fields.index
                                })
                                this.handleEditListTab('fields_services', params)
                            }}
                            onRemoveItem={(params) => this.handleRemoveFromListTab('fields_services', params)}
                            metadata={{
                                VendorID: {
                                    api: "api/" + Resources.VendorsQuick,
                                    query: {},
                                    searchMap: (item) => ({
                                        label: item.LegalName + ", " + item.AddressName,
                                        value: item.VendorID
                                    })
                                }
                            }}
                        />
                    )}

                    <PageFooter
                        translate={translate}
                        canSubmit={this.state.canSubmit}
                        actionCancel={this.handleFormCancel}
                        actionSubmit={checkPerm(Resources.Trailers, CREATE_PERM) && this.onSubmit}
                    />
                </Page>

                <RedirectDialog
                    show={this.state.redirectModalOpen}
                    title={translate('card_header.trailer_created')}
                    onClose={() => {
                        this.props.dispatch(resetResource())
                        this.setState({
                            createdResourceID: null,
                            redirectModalOpen: false
                        })
                    }}

                    createdLabel={translate('btn.trailer')}
                    createdLink={`/trailers/info/${this.state.createdResourceID}`}

                    newLabel={translate('btn.create_new')}

                    listLabel={translate('btn.list')}
                    listLink="/trailers"

                    dashboardLabel={translate('btn.dashboard')}

                    {...this.props}
                >
                    <p>{translate('message.trailer_created')}</p>
                </RedirectDialog>

                <GroupsViewDialog
                    groupID={this.state.fields_info?.ContactGroupID?.value?.value}
                    isGroupInfoDialogOpen={this.state.isGroupInfoDialogOpen}
                    groupInfoData={this.state.groupInfoData}
                    onClose={() => this.setState({
                        isGroupInfoDialogOpen: false
                    })}
                    translate={translate}
                />
            </Layout>
        )
    }
}

export default connect(state => state)(TrailerCreateView)

